import { useState } from "react";
import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl, Pager, Filters, Modal, F, clip } from "../lib/ui.jsx";

const CH = ["web", "mail", "sms", "android", "whatsapp", "phone_call", "ghoms"];

export default function Notifications() {
  const { api, act } = useAuth();
  const [f, setF] = useState({ search: "", from: "", to: "", page: 1 });
  const [d, reload] = useLoad("notifs", f);
  const [e, setE] = useState(null);
  const [hits, setHits] = useState([]);
  const [q, setQ] = useState("");

  const find = async () => {
    try { setHits((await api("users", { params: { search: q, per: 8 } })).rows); } catch { setHits([]); }
  };
  const send = async () => {
    const r = await act("notif_send", e);
    if (r) { alert(`Notification recorded for ${r.recipients} user(s).`); setE(null); reload(); }
  };

  return (
    <>
      <h1>Notifications</h1>
      <Filters f={f} setF={setF}>
        <button className="btn" onClick={() => { setE({ to: "all", title: "", description: "", priority: 0, ch_web: 1 }); setHits([]); setQ(""); }}>Send notification</button>
      </Filters>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <Tbl rows={d.rows} empty="No notifications yet." cols={[
              ["Sent", (n) => n.time_stamp], ["Title", (n) => clip(n.title, 40)], ["Message", (n) => clip(n.description, 60)],
              ["To", (n) => (n.to_user === "all" ? "All users" : n.to_name || n.to_user)], ["From", (n) => n.from_name || n.from_user],
              ["Read", (n) => `${n.read_count}/${n.recipients}`],
              ["", (n) => <button className="btn d s" onClick={() => confirm("Delete this notification and its recipient rows?") && act("notif_delete", { refer: n.refer }, "Deleted.").then(reload)}>Delete</button>],
            ]} />
            <Pager f={f} setF={setF} d={d} />
          </>
        )}
      </Wait>
      {e && (
        <Modal title="Send notification" onClose={() => setE(null)}>
          <label>Send to</label>
          <select value={e.to} onChange={(x) => setE({ ...e, to: x.target.value })}>
            <option value="all">All active users</option><option value="user">One user</option>
          </select>
          {e.to === "user" && (
            <>
              <div className="bar" style={{ margin: "6px 0 0" }}>
                <input value={q} onChange={(x) => setQ(x.target.value)} onKeyDown={(x) => x.key === "Enter" && find()} placeholder="Find user" />
                <button className="btn g" onClick={find}>Search</button>
              </div>
              <select size={Math.min(5, hits.length || 1)} style={{ width: "100%", marginTop: 6 }} value={e.sopnoid || ""} onChange={(x) => setE({ ...e, sopnoid: x.target.value })}>
                {hits.map((u) => <option key={u.SopnoID} value={u.SopnoID}>{u.Name} ({u.Email})</option>)}
              </select>
            </>
          )}
          <F label="Title" v={e.title} set={(v) => setE({ ...e, title: v })} />
          <label>Message</label>
          <textarea rows={4} value={e.description} onChange={(x) => setE({ ...e, description: x.target.value })} />
          <F label="Link or destination (optional)" v={e.destination} set={(v) => setE({ ...e, destination: v })} />
          <label>Priority</label>
          <select value={e.priority} onChange={(x) => setE({ ...e, priority: +x.target.value })}>
            <option value={0}>Normal</option><option value={1}>High</option>
          </select>
          <div className="g2" style={{ marginTop: 8 }}>
            {CH.map((c) => (
              <label className="chk" key={c}>
                <input type="checkbox" checked={!!e["ch_" + c]} onChange={(x) => setE({ ...e, ["ch_" + c]: x.target.checked ? 1 : 0 })} />
                {c.replace("_", " ")}
              </label>
            ))}
          </div>
          <div className="bar"><button className="btn" disabled={!e.title || !e.description || (e.to === "user" && !e.sopnoid)} onClick={send}>Send</button></div>
        </Modal>
      )}
    </>
  );
}
